import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { RequiredAsteriskModule } from 'src/app/@core/directives/required-asterisk/required-asterisk.module';
import { AuthTokenGenerationComponent } from './auth-token-generation.component';


@NgModule({
  declarations: [
    AuthTokenGenerationComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RequiredAsteriskModule,
    NgSelectModule,
    AccordionModule
  ],
  exports: [AuthTokenGenerationComponent]
})
export class AuthTokenGenerationModule { }
